module.exports = __webpack_public_path__ + "static/media/fpg_logo.1bdbb05c.png";